import React from "react";
import Lottie from "lottie-react";
import chamberLoadingAnimation from "../../images/chamberloading.json";

interface ChamberLoadingProps {
  size?: number;
}

const ChamberLoading: React.FC<ChamberLoadingProps> = ({ size = 300 }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: "20px 0",
      }}
    >
      <Lottie
        animationData={chamberLoadingAnimation}
        loop
        autoplay
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export default ChamberLoading;
